import { useQuery } from "@tanstack/react-query";

import { request } from "../api";
import { ShipOperationStatus } from "../types/ship";
import { GET_SHIP_OPERATION_STATUS } from "../query-keys";

const useShipOperationStatus = (currentShip: {
  shipTypeNo: string;
  shipNo: string;
}) => {
  // 상단 함정 운항 정보 조회
  const { data: shipOperationStatus, isFetching } = useQuery({
    queryKey: [
      GET_SHIP_OPERATION_STATUS,
      currentShip.shipTypeNo,
      currentShip.shipNo,
    ],
    queryFn: async () => {
      return await request<ShipOperationStatus>({
        method: "GET",
        url: `/ship-info/operation/status/dashboard`,
        params: {
          shipTypeNo: currentShip.shipTypeNo,
          shipNo: currentShip.shipNo,
        },
      });
    },
    refetchInterval: 10000,
    refetchIntervalInBackground: true,
  });

  return { shipOperationStatus, isFetching };
};

export default useShipOperationStatus;
